export enum PriceOverrideType {
  None = '',
  Extended = 'EnhancedPriceOverride',
  Regular = 'PriceOverride',
}
